import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { courseContainerWidth } from "Constants";
import { fetchSettings } from "TicketAction";
import { fetchUsersCategory } from "DashboardUserAction";
import {
  textAttachmentData,
  documentAttachmentData,
  videoAttachmentData,
  audioAttachmentData,
  linkAttachmentData,
  fetchAllCoursesNames,
} from "CourseAction";
import CoursesSubMenu from "./sub-menus";
import LocaleStrings from "Languages";

import Wizard from "CoursesWizard";
import Course from "ManageCourse";
import Quiz from "ManageQuiz";

class Courses extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let textAttachment = [
      { key: "text", fixed: true, value: "", field: "new", attid: "" },
    ];
    let documentAttachment = [
      {
        key: "document",
        fixed: true,
        file: "",
        filename: "",
        field: "new",
        attid: "",
      },
    ];
    let videoAttachment = [
      {
        key: "video",
        fixed: true,
        file: "",
        filename: "",
        thumbnail: "",
        field: "new",
        attid: "",
      },
    ];
    let audioAttachment = [
      {
        key: "audio",
        fixed: true,
        file: "",
        filename: "",
        field: "new",
        attid: "",
      },
    ];
    let linkAttachment = [
      { key: "link", fixed: true, value: "", field: "new", attid: "" },
    ];

    this.props.textAttachmentData(textAttachment);
    this.props.documentAttachmentData(documentAttachment);
    this.props.videoAttachmentData(videoAttachment);
    this.props.audioAttachmentData(audioAttachment);
    this.props.linkAttachmentData(linkAttachment);
    this.props.fetchAllCoursesNames(this.props.session);
    this.props.fetchSettings(this.props.session);
    this.props.fetchUsersCategory(this.props.session);
  }

  renderList() {
    return _.map(this.props.courseMenus, (item, index) => {
      return <CoursesSubMenu key={`key_${index}`} item={item} />;
    });
  }

  render() {
    return (
      <div>
        <div className="content-parent-container">
          <div className="content-submenu vertical-line">
            <ul className="list-group">{this.renderList()}</ul>
          </div>

          <div
            className="content-subcontainer"
            // style={{ width: `${courseContainerWidth}px` }}
          >
            <Route path="/dashboard/courses/wizard" component={Wizard} />
            <Route path="/dashboard/courses/course" component={Course} />
            <Route path="/dashboard/courses/quiz" component={Quiz} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    courseMenus: state.courseMenus,
  };
}

export default connect(mapStateToProps, {
  textAttachmentData,
  documentAttachmentData,
  videoAttachmentData,
  audioAttachmentData,
  linkAttachmentData,
  fetchAllCoursesNames,
  fetchSettings,
  fetchUsersCategory,
})(Courses);
